export const TIME_IN_STAGE_VISIBLE_STAGES = ['applied', 'reviewed'];

export const MS_PER_HOUR = 60 * 60 * 1000;
export const MS_PER_DAY = 24 * MS_PER_HOUR;
export const MS_PER_WEEK = 7 * MS_PER_DAY;

/**
 * Timestamp for when the candidate entered the current ATS stage.
 * Applied uses approved_at (when the pitch became an application),
 * falling back to timestamp (date sent). Reviewed uses reviewed_at.
 */
export const getStageEnteredAt = (stage, pitch) => {
  if (!pitch) return null;

  if (stage === 'reviewed') {
    return pitch.reviewed_at || null;
  }

  if (stage === 'applied') {
    return pitch.approved_at || pitch.timestamp || null;
  }

  return null;
};

const formatRoundedDuration = (elapsedMs) => {
  const hours = elapsedMs / MS_PER_HOUR;
  const days = elapsedMs / MS_PER_DAY;
  const weeks = elapsedMs / MS_PER_WEEK;

  if (elapsedMs < MS_PER_DAY) {
    const roundedHours = Math.round(hours);
    if (roundedHours >= 24) {
      return '1d';
    }
    return `${Math.max(0, roundedHours)}h`;
  }

  if (elapsedMs < MS_PER_WEEK) {
    const roundedDays = Math.round(days);
    if (roundedDays >= 7) {
      return '1w';
    }
    return `${Math.max(1, roundedDays)}d`;
  }

  const roundedWeeks = Math.max(1, Math.round(weeks));
  return `${roundedWeeks}w`;
};

const getTone = (elapsedMs) => {
  if (elapsedMs < 2 * MS_PER_DAY) {
    return 'blue';
  }
  if (elapsedMs <= 5 * MS_PER_DAY) {
    return 'yellow';
  }
  return 'red';
};

/**
 * Single-unit time-in-stage label and colour tone.
 * Hours until 24h, days until 7d, then weeks (`1w`). Colour: blue < 2d,
 * yellow 2–5d inclusive, red > 5d.
 */
export const formatTimeInStage = (startedAt, now = Date.now()) => {
  if (!startedAt) return null;

  const startMs = new Date(startedAt).getTime();
  if (Number.isNaN(startMs)) return null;

  const nowMs = new Date(now).getTime();
  if (Number.isNaN(nowMs)) return null;

  const elapsedMs = Math.max(0, nowMs - startMs);

  return {
    label: formatRoundedDuration(elapsedMs),
    tone: getTone(elapsedMs),
    elapsedMs,
  };
};
